import Bni from "./images/payment/bni.svg";
import Gopay from "./images/payment/gopay.svg";
import Jcb from "./images/payment/jcb.svg";
import Mandiri from "./images/payment/mandiri.svg";
import Mastercard from "./images/payment/mastercard.svg";
import Permata from "./images/payment/permata.svg";
import Qris from "./images/payment/qris.svg";
import Danamon from "./images/payment/danamon.svg";
import Bri from "./images/payment/bri.svg";
import Cimb from "./images/payment/cimb.svg";
import Visa from "./images/payment/visa.svg";
import GopayChecklist from "./images/finish/gopay-checklist.svg";
import CardChecklist from "./images/finish/cc-checklist.svg";
import Success from "./images/finish/success-illustration.svg";
import BankOthers from "./images/finish/bank_others.svg";
import midtransLogo from "./images/midtrans-blue.svg";
import checkoutLogo from "./images/tooltip/1_checkout.svg";
import tncLogo from "./images/tooltip/2_tnc.svg";
import contactUsLogo from "./images/tooltip/3_contact_us.svg";
import priceLogo from "./images/tooltip/4_price.svg";
import productDescLogo from "./images/tooltip/5_product-desc.svg";

export const PassportAssets = {
  midtransLogo,
  logo: {
    Bni,
    Gopay,
    Jcb,
    Mandiri,
    Mastercard,
    Permata,
    Qris,
    Visa,
    Danamon,
    Bri,
    Cimb,
  },
  success: {
    GopayChecklist,
    CardChecklist,
    Success,
    BankOthers,
  },
  tooltip: {
    checkoutLogo,
    tncLogo,
    contactUsLogo,
    priceLogo,
    productDescLogo,
  },
};
